import {fetchJSON} from "../../helpers/Helpers";
import AuthService from "../AuthService";

export default class GiftcardsApi {

    static callId = 0;

    static getGiftcard(cardNumber, callback) {

        GiftcardsApi.callId++;
        const callId = GiftcardsApi.callId;

        fetchJSON('/api/giftcards/' + cardNumber, {
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        })
            .then((response) => {
                callback(response, callId);
            })
            .catch((response) => {
                callback(response, callId);
            });

        return callId;
    }
}
